/**
 * PageShell - Flush page container (no Paper / panel chrome)
 */

import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const Shell = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  backgroundColor: "transparent",
  // MobileWrapper already supplies the page gutter
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2.5),
  },
}));

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 */
const PageShell = ({ children, className, ...rest }) => (
  <Shell className={className} data-page-shell="flush" {...rest}>
    {children}
  </Shell>
);

export default PageShell;
